import { withI18n } from '@lingui/react'
import classNames from 'clsx'
import { arrayOf, bool, number, shape, string } from 'prop-types'
import { compose } from 'redux'

import { CROSSSELL_CLASSNAME } from 'shared/consts/crosssellWidgets'
import {
  CHARGE_SEARCH_PARAMS,
  INIT_CROSSSELL,
  INIT_SLIDER,
  INIT_XSELL_TOP_SLIDER,
} from 'shared/store/ducks/events'
import { showBuyButtonForAllCSWExperiment } from 'views/containers/crosssell/CrosssellSliderHorizontal/utils'
import withCrossSell from 'views/enhancers/withCrossSell'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { i18nType, mountPointsType } from 'views/utils/propTypes'
import ProductType from 'views/utils/propTypes/api/Product_v1'

import SliderComponentCompact from './SliderComponentCompact'

const CrosssellSliderHorizontalCompact = props => {
  const {
    widgetdetails,
    publicRuntimeConfig: {
      pageProperties: { experiments },
    },
    shopConfig: {
      crosssell: { widgets },
    },
    i18n,
    crossSellType,
    wid,
    items,
    className,
    searchLink,
    mountPoints,
    moreLinkUrl,
    noSlider,
    metadata,
    redirectToCart,
    ...rest
  } = props

  if (!items) {
    return null
  }

  let finalWid = wid
  if (!wid && crossSellType) {
    finalWid = widgets[crossSellType]
  }

  let finalMoreLinkUrl = moreLinkUrl

  if (!finalMoreLinkUrl && searchLink) {
    finalMoreLinkUrl = mountPoints.getSearchProductsList(items)
  }

  return (
    <SliderComponentCompact
      {...rest}
      noSlider={noSlider}
      items={items}
      wid={finalWid}
      widgets={widgets}
      showBuyButton={showBuyButtonForAllCSWExperiment(experiments)}
      className={classNames(
        CROSSSELL_CLASSNAME,
        'o-SliderHorizontalCompact',
        className
      )}
      title={widgetdetails.title}
      moreLinkUrl={finalMoreLinkUrl}
      redirectToCart={redirectToCart}
      metadata={metadata}
      titleIsHtml
      adaptableArrows
    />
  )
}

CrosssellSliderHorizontalCompact.propTypes = {
  shopConfig: shape({
    crosssell: shape({
      widgets: shape({}).isRequired,
    }).isRequired,
  }).isRequired,
  publicRuntimeConfig: shape({
    pageProperties: shape({
      experiments: arrayOf(shape({}).isRequired).isRequired,
    }).isRequired,
  }).isRequired,
  mountPoints: mountPointsType.isRequired,
  i18n: i18nType.isRequired,
  items: arrayOf(shape(ProductType)),
  crossSellType: string,
  wid: number,
  visibleItemCount: number,
  pid: string,
  start: number,
  csize: number,
  'ctxcat.ct': string,
  'ctxcat.cid': string,
  searchLink: bool,
  asTopSlider: bool,
  widgetdetails: shape({
    title: string,
    moreLinkTitle: string,
  }),
  className: string,
  moreLinkUrl: string,
  metadata: shape({}),
  moreLinkTitle: string,
  noSlider: bool,
  redirectToCart: bool,
}

CrosssellSliderHorizontalCompact.defaultProps = {
  crossSellType: null,
  wid: null,
  visibleItemCount: 6,
  items: null,
  pid: null,
  start: 0,
  csize: 50,
  asTopSlider: false,
  'ctxcat.ct': null,
  'ctxcat.cid': null,
  searchLink: false,
  widgetdetails: {
    title: null,
    moreLinkTitle: null,
  },
  className: null,
  moreLinkUrl: null,
  moreLinkTitle: null,
  metadata: {},
  noSlider: false,
  redirectToCart: false,
}

CrosssellSliderHorizontalCompact.publishAfterRender = [
  INIT_SLIDER,
  CHARGE_SEARCH_PARAMS,
  INIT_CROSSSELL,
  INIT_XSELL_TOP_SLIDER,
]

export default compose(
  withCrossSell('/crosssell/sliderHorizontalCompact'),
  withI18n(),
  withShopAndRuntimeConfig,
  withMountPoints
)(CrosssellSliderHorizontalCompact)
